import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';  // Import the icons
import './authStyles/Login.css';
import { API_ROOT } from '../../supplementary_components/requests';
import { CustomLoadingIcon } from '../../supplementary_components/loading_icon';
function ResetPassword() {
    // const usenameObj = {"username": }
    // const [login, setLogin ] = useState(localStorage.getItem('current_username'));
    // const [oldPassword, setOldPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [passwordError, setPasswordError] = useState(null); // For password validation error
    const [requirements, setRequirements] = useState({
            minLength: false,
            hasLowerCase: false,
            hasNumber: false
        });
    const navigate = useNavigate();

    const validatePassword = (password) => {
        const minLength = 8;
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);

        setRequirements({
            minLength: password.length >= minLength,
            hasLowerCase,
            hasNumber
        });
    };

    const handlePasswordChange = (e) => {
        const { value } = e.target;
        setNewPassword(value);
        validatePassword(value); // Call this function while typing
    };

    const handleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleNewPasswordVisibility = () => {
        setShowNewPassword(!showNewPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(loading){
            return;
        }
        setLoading(true);
        setError(null);
        setMessage(null);

        // Check if all password conditions are met
        if (!requirements.minLength  || !requirements.hasLowerCase || !requirements.hasNumber) {
            setPasswordError('Please meet all the password requirements.');
            setLoading(false);
            return;
        }
        if(newPassword !== e.target.querySelector('#confirmPassword').value){
            setPasswordError(null);
            setError('Passwords must match.');
            setLoading(false);
            return;
        }
        setPasswordError(null);
        setError(null);
        const data = {
            login: localStorage.getItem('current_username'),
            oldPassword : localStorage.getItem('temp_password'),
            newPassword : newPassword
        }
        try {
            const response = await fetch(API_ROOT+'auth/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                setMessage('Your password has been successfully updated.');
                const data = await response.json();
                //navigate('/login');  // Redirect to login page after successful password update
                // Add a 2-second delay before navigating to the login page
                localStorage.setItem('access_token', data.access_token); // Store the access token
                localStorage.setItem('refresh_token', data.refresh_token); // Store the refresh token
                setTimeout(() => {
                    navigate('/');
                }, 1000);
            } else {
                setLoading(false);
                const errorData = await response.json();
                setError(errorData.message || 'Failed to update password. Please try again.');
            }
        } catch (error) {
            setLoading(false);
            console.error('Error during password reset:', error);
            setError('An error occurred. Please try again.');
        }
    };

    return (
        <div className="loginFormWrapper">
            <div className="loginFormBox">
                <div className="pageLabel">Reset Password</div>
                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="input-group password-group">
                        <label htmlFor="newPassword">New Password:</label>
                        <input
                            type={showNewPassword ? 'text' : 'password'}
                            id="newPassword"
                            value={newPassword}
                            onChange={handlePasswordChange}
                            required
                        />
                        <span className="password-toggle-icon" onClick={handleNewPasswordVisibility}>
                            {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                        {passwordError && <p className="error-message">{passwordError}</p>}
                    </div>
                    <div className="input-group password-group">
                        <label htmlFor="confirmPassword">Confirm Password:</label>
                        <input
                            type={showConfirmPassword ? 'text' : 'password'}
                            id="confirmPassword"
                            required
                        />
                        <span className="password-toggle-icon" onClick={handleConfirmPasswordVisibility}>
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>
                    {/* Display password requirements dynamically */}
                    <div className="password-requirements">
                        <p>Password must include the following:</p>
                        <ul>
                            <li style={{ color: requirements.minLength ? 'var(--main-color)' : 'var(--light-gray)' }}>
                                At least 8 characters long
                            </li>
                            <li style={{ color: requirements.hasLowerCase ? 'var(--main-color)' : 'var(--light-gray)' }}>
                                At least one lowercase letter
                            </li>
                            <li style={{ color: requirements.hasNumber ? 'var(--main-color)' : 'var(--light-gray)' }}>
                                At least one number
                            </li>
                        </ul>
                    </div>

                    <div className="submit-group reset-password">
                        <button type="submit" disabled={loading}>Reset Password</button>
                        {loading?<CustomLoadingIcon height={'1.2rem'} speed={1.0} strokeColor="white" />:null}
                    </div>
                    <div className="forgot-password">
                        <Link to="/login" className="back-to-login">Go back to Login</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ResetPassword;
